import { render, staticRenderFns } from "./CommissionOnTax.vue?vue&type=template&id=355ceba6&"
import script from "./CommissionOnTax.vue?vue&type=script&lang=ts&"
export * from "./CommissionOnTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports